import React, { useEffect, useState } from 'react';
import './Notification.css';

const Notification = ({ 
  type = 'info', 
  message, 
  duration = 3000, 
  onClose, 
  persistent = false,
  position = 'top-right'
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    if (!persistent && duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, persistent]);

  const handleClose = () => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300); // Match the animation duration
  };

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
      default:
        return 'fas fa-info-circle';
    }
  };

  return (
    <div className={`notification notification-${type} notification-${position} ${isLeaving ? 'notification-leaving' : ''}`}>
      <div className="notification-content">
        <i className={getIcon()}></i>
        <span className="notification-message">{message}</span>
        {!persistent && (
          <button className="notification-close" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default Notification;